import { IMessage, MessageType } from '@common/types';
import { cn } from '@lib/utils';
import AnswerMessageContainer from './answer-message-container';

interface LiveChatMessageProps {
  message: IMessage;
}

function LiveChatMessage(props: LiveChatMessageProps) {
  const isNotice = props.message.type === MessageType.LiveChatNotice;

  return (
    <AnswerMessageContainer>
      <div className={cn(isNotice ? 'text-sm text-slate-600' : 'text-[#13233a]')}>
        {props.message.senderName && !isNotice && (
          <div className="mb-1 text-xs font-semibold text-slate-500">
            {props.message.senderName}
          </div>
        )}
        <div
          className="markdown-renderer whitespace-normal break-words"
          dangerouslySetInnerHTML={{ __html: props.message.message }}
        />
      </div>
    </AnswerMessageContainer>
  );
}

export default LiveChatMessage;
